import { Button, Icon, Link } from '@chakra-ui/react';
import { NormalText } from '@carafe/components';
import { IoLogoApple } from 'react-icons/io5';
import { strings } from '@localisation';

interface Props {
  url: string;
}

export const AppleSignInButton = ({ url }: Props): JSX.Element => {
  return (
    <Button
      width="100%"
      border="1px solid"
      borderColor="gray.300"
      colorScheme="white"
      color="gray.900"
      fontSize="0.75rem"
      as={Link}
      href={url}
      isDisabled={!url.length}
    >
      <Icon as={IoLogoApple} w={5} h={5} />
      <NormalText ml={2} text={strings.social.apple} />
    </Button>
  );
};
